import request from '../../utils/request';
/**
 * 查询商户列表
 */
export const selectRegion = (item) => {
    return request({
        url: '/sys/RegionPayment/selectRegion',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};
/**
 * 查询商户列表
 */
export const selectMerchant = (item) => {
    return request({
        url: '/sys/RegionPayment/selectRegionPayment',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};

/**
 * 修改商户信息
 */
export const updateMerchant = (item) => {
    return request({
        url: '/sys/RegionPayment/updateRegionPayment',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};



/**
 * 月度汇总、月度折线图数据
 */
export const recordMonthSummary = (item) => {
    return request({
        url: '/sys/RegionPayment/RecordMonthSummary',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};


/**
 * 单商户列表
 */
export const selectMerchantList = (item) => {
    return request({
        url: '/sys/RegionPayment/page',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};

export const excelMerchantList = (item) => {
    return request({
        url: '/sys/RegionPayment/excel',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};

export const confiscate = (item) => {
    return request({
        url: '/sys/RegionPayment/confiscateRecord',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};

export const handNoAccountReminder = (item) => {
    return request({
        url: '/sys/RegionPayment/handNoAccountReminder',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(item),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};